import "babel-polyfill";
import "whatwg-fetch";
import "picturefill";
import "objectFitPolyfill";
import Vue from "vue";
import PortalVue from "portal-vue";

import "./components/higher-order/StaggerList";
import "./components/directives/v-focus";
import "./utilities/filters.js";
import { fragmentRedirects } from "./utilities/fragmentRedirects.js";
import { asyncScripts } from './utilities/asyncScripts.js';

import { getParams, applySpaces } from "utilities/getParams.js";

import ApiList from "./components/list/ApiList.vue";

// TODO: marked for removal
// import Config from './components/Config/Config.vue';
import CalendarMenu from "./components/CalendarMenu/CalendarMenu.vue";
import CareersList from "./components/list/CareersList.vue";
import DrawerGridSort from "./components/list/DrawerGridSort.vue";
import DrawerGrid from "./components/list/DrawerGrid.vue";
import DynamicFilter from "./components/list/DynamicFilter.vue";
import HeroCarousel from "./components/HeroCarousel/HeroCarousel.vue";
import List from "./components/list/List.vue";
import SearchList from "./components/list/SearchList.vue";
import ListDisplay from "./components/list/ListDisplay.vue";
import DivTable from "./components/list/DivTable.vue";
import DivTableSort from "./components/list/DivTableSort.vue";
import Modal from "./components/Modal/Modal.vue";
import Search from "./components/Search/Search.vue";
import SearchBar from "./components/SearchBar/SearchBar.vue";
import SiteHeader from "./components/landmarks/SiteHeader.vue";
import SiteFooter from "./components/landmarks/SiteFooter.vue";
import SocialFeed from "./components/SocialFeed/SocialFeed.vue";
import TeammatesGrid from "./components/TeammatesGrid/TeammatesGrid.vue";
import Toggle from "./components/Toggle.vue";
import VueTest from "./components/VueTest.vue";
import WithApi from "./components/higher-order/WithApi.vue";

import AwardItem from "./components/templates/AwardItem.vue";
import CardItem from "./components/templates/CardItem.vue";
import EventsItem from "./components/templates/EventsItem.vue";
import ListFilters from "./components/templates/ListFilters.vue";
import CareersListFilters from "./components/templates/CareersListFilters.vue";
import CareersListFiltersMulti from "./components/templates/CareersListFiltersMulti.vue";
import TabFilters from "./components/templates/TabFilters.vue";
import VideoWrapper from "./components/templates/VideoWrapper.vue";


Vue.use(PortalVue);

const VueApp = new Vue({
    el: "#app",
    data() {
        return {
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            socialLinks: [],
            autocompleteUrl: null,
            queryParamsObject: null,
            asyncScripts: []
        };
    },
    components: {
        ApiList,
        AwardItem,
        CardItem,
        CalendarMenu,
        EventsItem,
        // TODO: marked for removal
        // Config,
        CareersList,
        HeroCarousel,
        List,
        ListDisplay,
        ListFilters,
        CareersListFilters,
		CareersListFiltersMulti,
        DivTable,
		DivTableSort,
        DynamicFilter,
        TabFilters,
        Modal,
        Search,
        SearchBar,
        SiteHeader,
        SiteFooter,
        SocialFeed,
        SearchList,
        TeammatesGrid,
        DrawerGridSort,
        DrawerGrid,
        Toggle,
        VideoWrapper,
        VueTest,
        WithApi
    },
    mounted() {
        window.addEventListener("resize", this.getWindowDimensions);
        window.addEventListener("scroll", this.getWindowOffset);
    },
    beforeCreate() {
        fragmentRedirects(window.KohlerConfig.fragmentRedirects);
    },
    created() {
        // toggle js classes on load
        const siteHtml = document.querySelector("html");
        siteHtml.classList.toggle("no-js");
        siteHtml.classList.toggle("js");

        asyncScripts(window.KohlerConfig.asyncScripts);
    },
    methods: {
        getWindowDimensions(event) {
            this.windowWidth = event.target.innerWidth;
            this.windowHeight = event.target.innerHeight;
        },
        getWindowOffset(event) {
            this.windowScrollY = window.scrollY;
        }
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.getWindowDimensions);
        window.removeEventListener("scroll", this.getWindowOffset);
    }
});
